import type { QueueItem as QueueItemType } from '../types'
import QueueItem from './QueueItem.tsx'

interface QueueProps {
  items: QueueItemType[]
  onRemove: (id: string) => void
  onDownload: (id: string) => void
  onRetry: (id: string) => void
}

export default function Queue({ items, onRemove, onDownload, onRetry }: QueueProps) {
  if (items.length === 0) return null

  return (
    <div className="queue" role="list" aria-label="Files to convert">
      {items.map((item) => (
        <QueueItem
          key={item.id}
          item={item}
          onRemove={onRemove}
          onDownload={onDownload}
          onRetry={onRetry}
        />
      ))}
    </div>
  )
}
